import { useId, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useManagedModuleEditor } from '../../providers/managed-module-management-provider';
import '../../assets/authoring-checklist.css';

export function AuthoringChecklist() {
    const { authoringIssues = [], focusAuthoringIssue, addFragment, flushEditorChanges } = useManagedModuleEditor();
    const menuRef = useRef<Menu>(null);
    const menuId = useId();
    const [expanded, setExpanded] = useState(false);
    return <>
        <Button label={`Actions (${authoringIssues.length})`} icon="pi pi-chevron-down" iconPos="right"
            className="p-button-text p-button-sm" severity={authoringIssues.length ? 'danger' : undefined}
            aria-haspopup="menu" aria-controls={menuId} aria-expanded={expanded}
            tooltip={authoringIssues.length ? 'Required corrections before saving. Select an action to go to it.' : 'All authoring checks passed.'}
            tooltipOptions={{ position: 'top', event: 'both' }}
            onClick={event => { flushEditorChanges(); menuRef.current?.toggle(event); }} />
        <Menu ref={menuRef} id={menuId} popup className="authoring-checklist-menu" pt={{ menu: { 'aria-label': 'Authoring actions' } }}
            onShow={() => setExpanded(true)} onHide={() => setExpanded(false)}
            model={authoringIssues.length ? authoringIssues.map(issue => ({
                id: issue.id, label: issue.label, title: issue.message, command: () => {
                    if (issue.scope === 'module' && issue.field === 'fragments') addFragment();
                    else focusAuthoringIssue(issue);
                },
            })) : [{ label: 'All authoring checks passed.', disabled: true, icon: 'pi pi-check' }]} />
    </>;
}
